import { render, staticRenderFns } from "./BannerEditLandingPage.vue?vue&type=template&id=64144277"
import script from "./BannerEditLandingPage.vue?vue&type=script&lang=js"
export * from "./BannerEditLandingPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports